// @ts-strict-ignore
import React, { useState } from 'react';
import styled from 'styled-components';

import MetaData from '~/entities/evaluations/MetaData';
import { useFetchedUserContext } from '~/helpers/hooks';
import type { FeatureFlags } from '~/helpers/typescript';

import { useEventTypeEvaluationsContext } from '../context';

export const OtherDataWrapper = styled.div`
  width: 100%;

  > div {
    max-width: 100%;
    margin: 0;
  }
`;

const OtherData: React.FC = () => {
  const {
    constructWatchlistMatchDataObject,
    evaluation,
    isJourneyApplicationPage,
  } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags = {} as FeatureFlags } = useFetchedUserContext();

  const isWorkflowTypeRecurringWebhook = evaluation.evaluation_type === 'webhook';

  const [matchInfo] = useState(constructWatchlistMatchDataObject(
    evaluation.final_response,
  ));
  const meta = evaluation.final_response?.supplied?.meta;

  const shouldShowOtherData = (isWorkflowTypeRecurringWebhook || matchInfo.length === 0 || !featureFlags?.['sanctions-review']);

  if (!shouldShowOtherData) {
    return null;
  }

  return (
    <OtherDataWrapper>
      <MetaData
        meta={meta}
        finalResponse={evaluation.final_response}
        template={evaluation.meta_whitelist_template}
        evaluationApplicationId={evaluation.application_id}
        isJourneyApplicationPage={isJourneyApplicationPage}
        decisionType={evaluation.decision_type}
      />
    </OtherDataWrapper>
  );
};

export default OtherData;
